import { render, staticRenderFns } from "./HostAfricaServerWizard.vue?vue&type=template&id=17e7bf94&"
import script from "./HostAfricaServerWizard.vue?vue&type=script&lang=js&"
export * from "./HostAfricaServerWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports